import React, { useEffect, useRef, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import { WaveformContainer, Wave, PlayButton } from "./Waveform.styled";
import { AUDIO_PLAY_EVENT } from "../../../../../Helpers/Chat/Constant";
import { Recordplay, Recordpause } from "../../../../../assets/images";



const Waveform = ({ messageObject = {}, audioUrl = "", isSender, showProgressLoader = false }) => {
  const rawId = messageObject?.msgId ?? messageObject?.messageId ?? '';
  const msgId = rawId ? String(rawId) : '';
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [waveAudioDuration, setWaveAudioDuration] = useState(null);
  const [currentDuration, setCurrentDuration] = useState(null);

  function formatTime(seconds) {
    if (!seconds && seconds !== 0) return false;
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  useEffect(() => {
    if (!waveformRef.current) return;

    wavesurfer.current = WaveSurfer.create({
      container: waveformRef.current,
      waveColor: isSender ? "#ABBCD0" : "#809FAC",
      progressColor: isSender ? "#0D1116" : "#0D1116",
      cursorColor: "transparent",
      barWidth: 3,
      // cursorWidth: 1,
      height: 30,
      responsive: true,
      backend: "WebAudio",
      barGap: 3,
      normalize: true,
    });

    wavesurfer.current.on("ready", () => {
      setWaveAudioDuration(wavesurfer.current.getDuration());
    });

    wavesurfer.current.on("audioprocess", () => {
      const current = wavesurfer.current.getCurrentTime();
      setCurrentDuration(current);
    });

    wavesurfer.current.on("finish", () => setPlaying(false));

    return () => wavesurfer.current.destroy();
  }, []);

  useEffect(() => {
    if (wavesurfer.current && audioUrl) {
      wavesurfer.current.load(audioUrl);
    }
  }, [audioUrl]);

  useEffect(() => {
    const handleGlobalAudioPlay = (e) => {
    const detailId = e?.detail !== undefined && e.detail !== null ? String(e.detail) : '';
      if (detailId !== msgId && wavesurfer.current) {
        wavesurfer.current.pause();
        setPlaying(false);
      }
    };

    window.addEventListener(AUDIO_PLAY_EVENT, handleGlobalAudioPlay);
    return () => window.removeEventListener(AUDIO_PLAY_EVENT, handleGlobalAudioPlay);
  }, [msgId]);

  const handlePlayPause = () => {
    if (!wavesurfer.current) return;

    if (!playing) {
     window.dispatchEvent(new CustomEvent(AUDIO_PLAY_EVENT, { detail: msgId }));
    }

    wavesurfer.current.playPause();
    setPlaying((prev) => !prev);
  };

  return (
    <WaveformContainer>
      {!showProgressLoader && <PlayButton onClick={handlePlayPause} className={playing ? "playing" : "paused"}>
        {playing ? <Recordpause /> : <Recordplay />}
      </PlayButton>}
      <p>{playing ? formatTime(currentDuration) : formatTime(waveAudioDuration)}</p>
      <Wave ref={waveformRef} />
    </WaveformContainer>
  );
};

export default Waveform;
